import { styled } from '@mui/system';
import { IconButton, FormControlLabel } from '@mui/material';
import { TextFieldSelect } from 'shell/OnlineBookingTheme/components';

const BackButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(3),
    left: theme.spacing(1),
  }));

const HeaderWrapper = styled('header', {target: 'HeaderWrapper'})(({ theme }) => ({
  alignItems: 'center',
  minHeight: '4em',
  maxHeight: '5em',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0,1),
    '@media (max-height: 480px)': {
      justifyContent: 'space-between',
      minHeight: '4em',
    }
    },
}))

const LanguageWrapper = styled('div', {target: 'LanguageWrapper'})(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '@media (max-height: 480px)': {
      display: 'flex',
      justifyContent: 'center',
      width: '20%',
      minWidth: '75px'
    }
  }

}))

  const QFlowLogo = styled('div', {target: 'QFlowLogo'})(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    width: 'auto',
    minWidth: '75px',
    height: 'auto',
    padding: theme.spacing(0.5),
    maxHeight: '5em',
    '& img':{
      padding: theme.spacing(0.5,0),
      maxHeight: '5em',
      width: '100%',
      verticalAlign: 'middle',
      objectFit: 'contain'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '20%',
      marginRight: '20%',
      width: '80%',
      '@media (max-height: 480px)': {
        margin: 0,
        padding: 0,
        width: '20%',
        '& img': {
          maxHeight: '74px',
        }
      }
    }
  }))

  const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: theme.spacing(0),
    position: 'fixed',
    [theme.breakpoints.down('sm')]: {
      '@media (max-height: 480px)': {
        top: theme.spacing(1),
        right: -7
      }
    }
  }))

  const LanguageSelector = styled(TextFieldSelect, {target: 'LanguageSelector'})(({ theme }) => ({
    position: 'fixed',
    overflow: 'hidden',
    right: `${theme.spacing(3)} /* @noflip */`,
    width: '74px',
    height: '40px',
    '& .MuiSelect-select':{
      paddingLeft: '16px'
    },
    '& .Mui-selected':{
      backgroundColor: 'var(--mui-palette-secondary-main)',
    },
    '& .MuiMenuItem-root':{
      justifyContent: 'center'
    },
    '& > div': {
      background: '#fff',
      '& > div':{
        padding: 0
      }
    },

    [theme.breakpoints.down('sm')]: {
      right: `${theme.spacing(1)} /* @noflip */`,
      '@media (max-height: 480px)': {
        position: 'inherit',
        marginTop: theme.spacing(0.5)
      }
    }
  }))


  export { BackButton, QFlowLogo, LanguageSelector, HeaderWrapper, LanguageWrapper, StyledFormControlLabel }